// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Hwdg5","new-style":"Button_new-style__ygdZy","delete-style":"Button_delete-style__RNJFw","edit":"Button_edit__VGNc3","action":"Button_action__qSwZ2"};